var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00172 8.21678C5.69871 8.21678 5.3959 8.09995 5.16649 7.87054L1.90649 4.61054C1.83317 4.53721 1.83317 4.41341 1.90649 4.34009C1.97982 4.26676 2.10362 4.26676 2.17694 4.34009L5.43694 7.60009C5.74862 7.91176 6.25482 7.91176 6.56649 7.60009L9.82649 4.34009C9.89982 4.26676 10.0236 4.26676 10.0969 4.34009C10.1703 4.41341 10.1703 4.53721 10.0969 4.61054L6.83694 7.87054C6.60754 8.09995 6.30473 8.21678 6.00172 8.21678Z",
    fill: "white",
    stroke: "#92ABFE",
    strokeWidth: 0.367059
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.4e4d259c96978e61ddbecf27c7b582fc.svg";
export { ForwardRef as ReactComponent };